import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=25105190"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25105190')) {
      api.createRecord('25105190', component.options)
    } else {
      api.reload('25105190', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=25105190", function () {
      api.rerender('25105190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/UserForm.vue"
export default component.exports